import classnames from "classnames"
import React, { FC, PropsWithChildren, ReactNode } from "react"
import tw from "tailwind-styled-components"

export const ModalTitle = tw.h1`
    text-xl
`

export const UnderlineWrapper = tw.div`
  w-full
  p
  border-white
  border-opacity-7
`
export const FooterWrapper = tw.div`
  border-t
  border-white
  border-opacity-7
`
export const FooterContentWrapper = tw.div`
text-sm
text-white/60
font-normal
px-6
pr-3
py-3
`

export const ModalContentWrapper = tw.div<{ $disableOverflowStyle?: boolean }>`
  p-6
  pr-3
  font-normal


  ${({ $disableOverflowStyle }) => {
    if ($disableOverflowStyle) {
      return ""
    }
    return `
      overflow-x-scroll
      overflow-y-hidden
      flex
      flex-col
      items-stretch
    `
  }}
`

export const LayoutModal: FC<
  PropsWithChildren<{
    hidden?: boolean
    title: ReactNode | string
    titleMargin?: string
    footer?: ReactNode | string
    alert?: boolean
    skipChildren?: boolean
    nested?: boolean
    noPadding?: boolean
    showsTitleDivider?: boolean
    disableOverflowStyle?: boolean
    stickyTitle?: boolean
    bodyClassName?: string
    cardClassName?: string
  }>
> = ({
  skipChildren = false,
  hidden = false,
  title,
  titleMargin,
  children,
  alert,
  footer,
  nested = false,
  noPadding = false,
  showsTitleDivider = true,
  disableOverflowStyle = false,
  stickyTitle = false,
  bodyClassName = "",
  cardClassName = "bg-grayscale-darker",
}) => {
  if (hidden) {
    return null
  }
  return (
    <div
      className={`
      font-bold mb-5 border ${
        nested
          ? "bg-none border-l-0 border-r-0 border-b-0 border-grayscale-light border-opacity-40"
          : `rounded-xl overflow-hidden ${cardClassName} border-white border-opacity-7`
      } ${!!alert ? "border-alert-background border" : ""}`}
    >
      <UnderlineWrapper
        className={classnames({
          "border-b": !skipChildren && showsTitleDivider,
          "sticky top-0 rounded-tr-2xl rounded-tl-2xl !z-10": stickyTitle,
          [cardClassName]: true,
        })}
      >
        <ModalContentWrapper
          className={`${alert ? "text-alert-primary" : ""} ${titleMargin ? titleMargin : "py-3"}`}
          $disableOverflowStyle={disableOverflowStyle}
        >
          {title}
        </ModalContentWrapper>
      </UnderlineWrapper>
      {skipChildren ? (
        <></>
      ) : noPadding ? (
        <div className={`font-normal ${bodyClassName}`}>{children}</div>
      ) : (
        <ModalContentWrapper
          className={`font-normal ${bodyClassName}`}
          $disableOverflowStyle={disableOverflowStyle}
        >
          {children}
        </ModalContentWrapper>
      )}
      {footer ? (
        <FooterWrapper>
          <FooterContentWrapper>{footer}</FooterContentWrapper>
        </FooterWrapper>
      ) : null}
    </div>
  )
}

export const ModalHeaderWrapper = tw.div`
flex
items-center
justify-between
`

export const ModalHeaderTitle = tw.h3`
  inline-block
`

export const ModalHeader: FC<
  PropsWithChildren<{
    title: string | React.ReactNode
  }>
> = ({ title, children }) => {
  return (
    <ModalHeaderWrapper>
      <ModalHeaderTitle>{title}</ModalHeaderTitle>
      {children}
    </ModalHeaderWrapper>
  )
}
